/**
 * Whether the cart holds a promo the customer hasn't finished — the gate for the
 * "Incomplete promos in cart" checkout modal (`confirmIncompletePromos` in cart-functions.ts).
 * DOM-free on purpose so it can be unit-tested; cart-functions.ts imports it.
 *
 * An item belongs to an active promo (attributes.promoId is set) that isn't done yet
 * (promoCompleted !== true). The flag is the backend's call — see CartItem.promoCompleted in
 * contracts/cart.ts: validate's isComplete, or for a tiered chain an earned tier with its reward
 * row in the cart — so this stays a plain read and the rule lives in one place.
 *
 * Promos the customer explicitly declined (dismissedPromoIds — e.g. "No thanks" on a reward)
 * are excluded: dismissPromo() only strips the system/promo reward items, so the qualifying
 * 'cart' item keeps its promoId/promoCompleted:false indefinitely and would otherwise nag forever.
 */
export function hasIncompletePromos(cartData: any): boolean {
  const items = cartData?.cart?.items;

  if (!items) {
    return false;
  }

  const dismissedPromoIds: number[] = cartData?.cart?.dismissedPromoIds ?? [];

  return Object.values(items).some((item: any) => {
    const promoId = item?.attributes?.promoId;

    if (promoId === null || promoId === undefined) {
      return false;
    }

    if (dismissedPromoIds.includes(promoId)) {
      return false;
    }

    return item.promoCompleted !== true;
  });
}
